import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './screens/Home';
import HomeTablet from './screens/HomeTablet';
import HomeDesktop from './screens/HomeDesktop';
import About from './screens/About';
import AboutDesktop from './screens/AboutDesktop';
import Services from './screens/Services';
import ServicesDesktop from './screens/ServicesDesktop';
import Booking from './screens/Booking';
import BookingDesktop from './screens/BookingDesktop';
import Contact from './screens/Contact';
import ContactDesktop from './screens/ContactDesktop';
import { defaultTheme } from './theme';
import useBreakpoint from './hooks/useBreakpoint';

function MobileShell({ t, children }) {
  return (
    <div style={{
      minHeight: '100dvh',
      background: t.ink,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
    }}>
      <div
        className="mp-shell"
        style={{
          width: 'min(100vw, 480px)',
          height: '100dvh',
          maxHeight: 920,
          minHeight: 640,
          position: 'relative',
          overflow: 'hidden',
          background: t.paper,
          color: t.ink,
          boxShadow: '0 30px 60px rgba(0,0,0,0.18)',
        }}
      >
        {children}
      </div>
    </div>
  );
}

const WIDE_ROUTES = {
  '/about': AboutDesktop,
  '/services': ServicesDesktop,
  '/book': BookingDesktop,
  '/contact': ContactDesktop,
};

export default function App() {
  const t = defaultTheme;
  const bp = useBreakpoint();
  const { pathname } = useLocation();
  const isWide = bp === 'desktop' || bp === 'tablet';

  // Home: dedicated layouts at every breakpoint.
  if (pathname === '/' && bp === 'desktop') return <HomeDesktop t={t} />;
  if (pathname === '/' && bp === 'tablet') return <HomeTablet t={t} />;

  // Other routes: wide-screen layouts at tablet+ desktop, mobile shell at <768.
  if (isWide && WIDE_ROUTES[pathname]) {
    const WideScreen = WIDE_ROUTES[pathname];
    return <WideScreen t={t} />;
  }

  return (
    <MobileShell t={t}>
      <Routes>
        <Route path="/" element={<Home t={t} />} />
        <Route path="/about" element={<About t={t} />} />
        <Route path="/services" element={<Services t={t} />} />
        <Route path="/book" element={<Booking t={t} />} />
        <Route path="/contact" element={<Contact t={t} />} />
        <Route path="*" element={<Home t={t} />} />
      </Routes>
    </MobileShell>
  );
}
